import { JustifyAlignValue } from '@lib/style/utils';
import CircularProgress, { CircularProgressProps } from '@material-ui/core/CircularProgress';
import Fade from '@material-ui/core/Fade';
import { PositionedBox } from '@packages/layout/lib/Blocks';
import { PositionedBoxProps } from '@packages/layout/lib/Blocks/PositionedBox';
import { createMemo } from '@packages/react';
import { BackdropBlur } from '@packages/ui/elements/BackdropBlur';
import { BackdropBlurProps } from '@packages/ui/elements/BackdropBlur/BackdropBlur';
import React from 'react';
import { Row } from './Layout/Row';

interface TopLoaderProps extends PositionedBoxProps {
    show: boolean;
    full?: boolean;
    size?: string | number;
    color?: CircularProgressProps['color'];
    z?: number;
    padding?: string | number;
    align?: JustifyAlignValue;
    justify?: JustifyAlignValue;
    circularProps?: CircularProgressProps;
    backdropBlurProps?: BackdropBlurProps;
}

export const TopLoader = createMemo<TopLoaderProps>(
    ({
        show,
        full,
        size = 30,
        color = 'primary',
        z = 20,
        padding = 20,
        align = 'center',
        justify = 'center',
        circularProps = {},
        position = 'absolute',
        backdropBlurProps = {},
        ...rest
    }) => {
        if (full) {
            rest.t = rest.t ?? 0;
            rest.l = rest.l ?? 0;
            rest.r = rest.r ?? 0;
            rest.b = rest.b ?? 0;
        }

        return (
            <Fade unmountOnExit in={show}>
                <BackdropBlur tintOpacity={0.8} {...backdropBlurProps}>
                    <PositionedBox
                        component={Row}
                        position={position}
                        z={z}
                        t={0}
                        l={0}
                        r={0}
                        padding={padding}
                        align={align}
                        justify={justify}
                        {...rest}
                    >
                        <CircularProgress color={color as any} size={size} {...circularProps} />
                    </PositionedBox>
                </BackdropBlur>
            </Fade>
        );
    },
    {
        displayName: 'TopLoader',
    },
);
